import { gql } from '@apollo/client'

export { BRAZE_PROFILE_EXPORT_FIELD_KEYS } from './constants'

/**
 * Load Braze profile attributes for a member (user_info uuid = Braze external_id).
 */
export const GET_BRAZE_USER_PROFILE_ATTRIBUTES = gql`
  query BrazeUserProfileAttributes($uuid: ID!, $fields: [String!]) {
    brazeUserProfileAttributes(uuid: $uuid, fields: $fields) {
      uuid
      brazeId
      loadedAt
      attributes
    }
  }
`

export const EVENT_LOG_USER_ATTRIBUTES_UPDATE = gql`
  mutation EventLogUserAttributesUpdate($input: EventLogInput!) {
    eventLog(input: $input) {
      success
      message
    }
  }
`

export const EVENT_LOG_SUBSCRIPTION_QA = gql`
  mutation EventLogSubscriptionQa($input: EventLogInput!) {
    eventLog(input: $input) {
      success
      message
    }
  }
`
